var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 71.1",
    style: {
      enableBackground: "new 0 0 71.6 71.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5C2881;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.8,
    cy: 35.4,
    r: 35.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,30.9c0-2.3-1.9-4.2-4.2-4.2c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2C38.1,35.1,40,33.3,40,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,50.9C33.5,50.9,33.5,50.9,33.5,50.9c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.2 c0,0,0,0,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0 c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0 c0.2-0.2,0.4-0.4,0.6-0.6c0,0,0,0,0,0c0.2-0.2,0.5-0.5,0.7-0.7c0,0,0,0,0,0c0,0,0,0,0,0c3.7-3.8,10.6-12,10.6-19.7 c0-7.4-6.1-13.4-12.9-13.4s-12.9,6-12.9,13.4C22.9,39,29.8,47.1,33.5,50.9L33.5,50.9z M28.9,30.9c0-3.8,3.1-7,7-7c3.8,0,7,3.1,7,7 c0,3.8-3.1,7-7,7C32,37.9,28.9,34.8,28.9,30.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.80fdebdee0dc255340a5e1092228cf1c.svg";
export { ForwardRef as ReactComponent };